import angular from 'angular';

import FolderFilters from './folder-filter.data';

angular
  .module('dashboard')

  .controller('FolderCtrl', [
    '$scope',
    '$sessionStorage',
    '$translate',
    'dateFilter',
    'FolderService',
    'uiGridConstants',
    'FOLDER_STATUS',
    'DateService',
    'UtilSvc',
    function(
      $scope,
      $sessionStorage,
      $translate,
      dateFilter,
      FolderService,
      uiGridConstants,
      FOLDER_STATUS,
      DateService,
      UtilSvc
    ) {
      $scope.criteriaFol = {
        folderId: [],
        folderStatus: [],
        envelopeId: [],
        principalId: [],
        sender: [],
        senderName: [],
        senderEmail: [],
        companyName: [],
        refClient: [],
        createdDateFrom: [],
        createdDateTo: [],
        createdTimeFrom: [],
        createdTimeTo: [],
        updatedDateFrom: [],
        updatedDateTo: [],
        updatedTimeFrom: [],
        updatedTimeTo: []
      };

      $scope.foldersStatus = FOLDER_STATUS;
      initFoldersSearchFilter();
      initFoldersSearchValues();

      $scope.selected = {};

      // Paramètre indiquant si les critères de recherche doivent être initialisés suivant une configuration spéciale
      var specificForm = $scope.specificFormFolder;

      if (specificForm === 'folder_created') {
        // Critères de recherche par défaut OK
      }

      $scope.clearSearchFolders = function() {
        initFoldersSearchFilter();
        initFoldersSearchValues();
        $scope.foldersGridOptions.data = searchByCriterias();
        $sessionStorage.folderHistorySearchCriteria = $scope.criteriaFol;
      };

      $scope.searchFolders = function() {
        cleanFoldersFormParam();
        $scope.foldersGridOptions.data = searchByCriterias();
        $scope.folderPromise = $scope.foldersGridOptions.data.$promise;
        $sessionStorage.folderHistorySearchCriteria = $scope.criteriaFol;
      };

      var defaultCellTemplate =
        '<a class="grid-cell-link" ui-sref="folder_details({ folderId : row.entity.folderId })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{COL_FIELD CUSTOM_FILTERS}}</div></a>';
      var statusCellTemplate =
        '<a class="grid-cell-link" ui-sref="folder_details({ folderId : row.entity.folderId })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{COL_FIELD | translate}} {{row.entity.folderStatus == "ERROR" ? ("status.error_" + row.entity.folderErrorCode | translate) : ""}}</div></a>';

      $scope.foldersGridOptions = {
        columnDefs: [
          {
            name: 'folderId',
            displayName: 'dashboard.column.folder.folder.id',
            cellTemplate: defaultCellTemplate,
            headerCellFilter: 'translate',
            type: 'number'
          },
          {
            name: 'created',
            displayName: 'dashboard.column.envelope.created',
            cellTemplate: defaultCellTemplate,
            headerCellFilter: 'translate',
            sort: { direction: uiGridConstants.DESC, priority: 0 },
            cellFilter: "date:'short'"
          },
          {
            name: 'folderStatus',
            displayName: 'dashboard.column.envelope.status',
            cellTemplate: statusCellTemplate,
            headerCellFilter: 'translate',
            cellFilter: 'translate',
            sortingAlgorithm: function(a, b, rowA, rowB, direction) {
              return sortingStatus(a, b, rowA, rowB, direction);
            }
          },
          {
            name: 'updated',
            displayName: 'dashboard.column.folder.last.modified',
            cellTemplate: defaultCellTemplate,
            headerCellFilter: 'translate',
            cellFilter: "date:'short'"
          },
          {
            name: 'envelopeId',
            displayName: 'dashboard.column.envelope.id',
            cellTemplate: defaultCellTemplate,
            headerCellFilter: 'translate',
            type: 'number'
          },
          {
            name: 'rank',
            displayName: 'dashboard.column.folder.rank',
            cellTemplate: defaultCellTemplate,
            headerCellFilter: 'translate'
          },
          {
            name: 'principalName',
            displayName: 'dashboard.column.envelope.principal',
            cellTemplate: defaultCellTemplate,
            headerCellFilter: 'translate',
            type: 'string'
          },
          {
            name: 'companyName',
            displayName: 'dashboard.column.envelope.company.name',
            cellTemplate: defaultCellTemplate,
            headerCellFilter: 'translate'
          },
          {
            name: 'sender',
            displayName: 'dashboard.column.envelope.sender',
            cellTemplate: defaultCellTemplate,
            headerCellFilter: 'translate'
          },
          {
            name: 'senderEmail',
            displayName: 'dashboard.column.envelope.sender.email',
            cellTemplate: defaultCellTemplate,
            headerCellFilter: 'translate'
          },
          {
            name: 'refClient',
            displayName: 'dashboard.column.envelope.reference',
            cellTemplate: defaultCellTemplate,
            headerCellFilter: 'translate'
          }
        ],
        enableGridMenu: false,
        enableRowSelection: true,
        enableSelectAll: true,
        selectionRowHeaderWidth: 30,
        exporterMenuCsv: false,
        exporterMenuPdf: false,
        exporterCsvColumnSeparator: ';',
        enableColumnMenus: false,
        exporterOlderExcelCompatibility: true,
        exporterHeaderFilter: $translate.instant,
        exporterFieldCallback: function(grid, row, col, value) {
          if (col.name === 'created' || col.name === 'updated') {
            value = dateFilter(value, 'shortDate');
          } else if (col.name === 'folderStatus') {
            value = $translate.instant(value);
          }
          return value;
        },
        gridMenuTitleFilter: $translate,
        onRegisterApi: function(gridApi) {
          $scope.gridFoldersApi = gridApi;
        }
      };

      function sortingStatus(a, b, rowA, rowB /*, direction*/) {
        var statusTransA = $translate.instant(a);
        var statusTransB = $translate.instant(b);

        if (a === 'ERROR') {
          statusTransA += ' ' + $translate.instant('status.error_' + rowA.entity.folderErrorCode);
        }
        if (b === 'ERROR') {
          statusTransB += ' ' + $translate.instant('status.error_' + rowB.entity.folderErrorCode);
        }
        return statusTransA.localeCompare(statusTransB);
      }

      (function() {
        var folderHistorySearchCriteria = $sessionStorage.folderHistorySearchCriteria;
        if (folderHistorySearchCriteria && !specificForm) {
          $scope.criteriaFol = folderHistorySearchCriteria;
        }
      })();

      function searchByCriterias() {
        var criterias = new FolderFilters();
        var createdDateFrom = UtilSvc.mixteDateTime(
          $scope.criteriaFol.createdDateFrom,
          $scope.criteriaFol.createdTimeFrom
        );
        criterias.setCreatedDateFrom(createdDateFrom);
        var createdDateTo = UtilSvc.mixteDateTime($scope.criteriaFol.createdDateTo, $scope.criteriaFol.createdTimeTo);
        criterias.setCreatedDateTo(createdDateTo);

        var updatedDateFrom = UtilSvc.mixteDateTime(
          $scope.criteriaFol.updatedDateFrom,
          $scope.criteriaFol.updatedTimeFrom
        );
        criterias.setUpdatedDateFrom(updatedDateFrom);
        var updatedDateTo = UtilSvc.mixteDateTime($scope.criteriaFol.updatedDateTo, $scope.criteriaFol.updatedTimeTo);
        criterias.setUpdatedDateTo(updatedDateTo);

        criterias.setCompanyName($scope.criteriaFol.companyName);
        criterias.setSenderName($scope.criteriaFol.senderName);
        criterias.setEnvelopeId($scope.criteriaFol.envelopeId);
        criterias.setFolderId($scope.criteriaFol.folderId);
        criterias.setFolderStatus($scope.criteriaFol.folderStatus);
        criterias.setPrincipalId($scope.criteriaFol.principalId);
        criterias.setRank($scope.criteriaFol.rank);
        criterias.setRefClient($scope.criteriaFol.refClient);
        criterias.setSender($scope.criteriaFol.sender);
        criterias.setSenderEmail($scope.criteriaFol.senderEmail);

        return FolderService.searchByCriterias(criterias);
      }

      function initFoldersSearchValues() {
        $scope.criteriaFol.createdDateFrom = new Date();
        $scope.criteriaFol.createdDateFrom.setHours(0, 0, 0, 0);
        $scope.criteriaFol.createdDateTo = new Date();
        $scope.criteriaFol.createdDateTo.setHours(0, 0, 0, 0);
        $scope.criteriaFol.createdTimeFrom = new Date();
        $scope.criteriaFol.createdTimeFrom.setHours(0, 0, 0, 0);
        $scope.criteriaFol.createdTimeTo = new Date();
        $scope.criteriaFol.createdTimeTo.setHours(23, 59, 0, 0);
        $scope.criteriaFol.updatedTimeFrom = new Date();
        $scope.criteriaFol.updatedTimeFrom.setHours(0, 0, 0, 0);
        $scope.criteriaFol.updatedTimeTo = new Date();
        $scope.criteriaFol.updatedTimeTo.setHours(23, 59, 0, 0);
      }

      function cleanFoldersFormParam() {
        if ($scope.criteriaFol.folderStatus === '') {
          $scope.criteriaFol.folderStatus = undefined;
        }
        $scope.criteriaFol.companyName = $scope.selected.company && $scope.selected.company.companyName;
        $scope.criteriaFol.senderName = $scope.selected.seller && $scope.selected.seller.legalEntity && $scope.selected.seller.legalEntity.name;
      }

      function initFoldersSearchFilter() {
        $scope.criteriaFol.folderId = undefined;
        $scope.criteriaFol.folderStatus = undefined;
        $scope.criteriaFol.envelopeId = undefined;
        $scope.criteriaFol.principalId = undefined;
        $scope.criteriaFol.sender = undefined;
        $scope.criteriaFol.senderEmail = undefined;
        $scope.criteriaFol.companyName = undefined;
        $scope.criteriaFol.senderName = undefined;
        $scope.criteriaFol.refClient = undefined;
        $scope.criteriaFol.createdDateFrom = undefined;
        $scope.criteriaFol.createdDateTo = undefined;
        $scope.criteriaFol.createdTimeFrom = undefined;
        $scope.criteriaFol.createdTimeTo = undefined;
        $scope.criteriaFol.updatedDateFrom = undefined;
        $scope.criteriaFol.updatedDateTo = undefined;
        $scope.criteriaFol.updatedTimeFrom = undefined;
        $scope.criteriaFol.updatedTimeTo = undefined;
      }

      // Indique si l'export CSV de la grille peut être réalisé
      $scope.canExportGridCsv = function() {
        if (!($scope.gridFoldersApi === undefined || $scope.gridFoldersApi.selection === undefined)) {
          return $scope.gridFoldersApi.selection.getSelectedRows().length > 0;
        }
        return false;
      };

      // Exporte toutes les colonnes des lignes sélectionnées dans un fichier CSV
      $scope.exportGridCsv = function() {
        // Nom du fichier CSV : epdf_DateHeure_dataDossiers.csv
        var now = new Date();
        var filename = 'epdf_' + DateService.formatAsYMD_HM(now) + '_dataDossiers.csv';
        $scope.foldersGridOptions.exporterCsvFilename = filename;

        var myElement = angular.element(document.querySelectorAll('.custom-csv-link-location'));
        $scope.gridFoldersApi.exporter.csvExport('selected', 'all', myElement);
      };
    }
  ]);
